export enum TimeLogStatus {
  ON_TIME = 'ON_TIME',
  LATE = 'LATE',
  EARLY = 'EARLY',
  MISSING = 'MISSING',
}

export type ProfessionalsWorkJourneyTimeLog = {
  time: string;
  status: TimeLogStatus;
  extraTime?: string;
};

export type ProfessionalsWorkJourneyWorkLogs = {
  firstEntry: ProfessionalsWorkJourneyTimeLog;
  firstExit: ProfessionalsWorkJourneyTimeLog;
  secondEntry: ProfessionalsWorkJourneyTimeLog;
  secondExit: ProfessionalsWorkJourneyTimeLog;
};

export type ProfessionalsWorkJourneyDay = {
  date: string;
  /** Vinculo do profissional naquele dia, quando difere do vinculo principal. */
  role?: string;
  location: {
    name: string;
    address: string;
  };
  workLogs: ProfessionalsWorkJourneyWorkLogs;
};

export type ProfessionalsWorkJourneyProfessional = {
  id: string;
  name: string;
  photo: string;
  role: string;
  days: ProfessionalsWorkJourneyDay[];
};

export type ProfessionalsWorkJourneyOrganization = {
  id: string;
  name: string;
  professionals: ProfessionalsWorkJourneyProfessional[];
};

export type GetProfessionalsWorkJourneyResponse = {
  /** Total de profissionais que atendem aos filtros (unidade de paginacao). */
  total: number;
  data: ProfessionalsWorkJourneyOrganization[];
};
